<template>
	<div class="login" :class="[isPhone ? 'phone' : '']">
		<img
			class="left-image"
			src="https://i.gsxcdn.com/2109840444_y2t1i3s9.png"
			alt=""
		/>
		<img
			class="right-top"
			src="https://i.gsxcdn.com/2109840442_8o4grafo.png"
			alt=""
		/>
		<img
			class="right-bottom"
			src="https://i.gsxcdn.com/2109840443_bmfhasi3.png"
			alt=""
		/>
		<div class="login-content">
			<div class="login-content__title">
				<h1>途途朗读教师端</h1>
				<h6>教学好帮手</h6>
				<img src="https://i.gsxcdn.com/2109840441_z23d9ou0.png" />
				<t-button large class="phone-button" @click="showCode = true"
					>开始使用</t-button
				>
			</div>
			<div class="login-content__code" v-loading="loading">
				<!-- <div
					class="img fcc bg"
					:style="{ backgroundImage: `url(${codeUrl})` }"
				>

				</div> -->
				<vue-qr class="img" :text="codeUrl"></vue-qr>
				<div class="login-content__code--tips bg">
					使用微信或途途朗读教师端小程序进行扫码
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import { getLoginCode, getLoginStatus } from '@/api';
import { mapState } from 'vuex';
import Popup from 'vant/lib/popup';
import Toast from 'vant/lib/toast';
import vueQr from 'vue-qr';
import {
	lsweb0001,
	lsweb0002,
} from '@/utils/track/track'

export default {
	data() {
		return {
			showCode: false,
			loading: false,
			showTimeout: false,
			codeUrl: ''
		};
	},
	components: {
		Popup,
		vueQr
	},
	computed: {
		...mapState(['isPhone'])
	},
	methods: {
		fetchCode() {
			this.loading = true;
			getLoginCode().then((res) => {
				this.loading = false;
				this.codeUrl = `https://heya-reading.genshuixue.com/mp?w=web&key=${res.data.key}`;
				this.key = res.data.key;
				this.n = 0;
				this.refreshStatus();
			});
		},
		refreshStatus() {
			this.timer = setTimeout(() => {
				getLoginStatus({
					from_user: this.$route.query.id,
					key: this.key
				}).then((res) => {
					const { token, userInfo } = res.data;

					this.clear();

					if (token) {
						lsweb0002.send()
						this.clear();
						if (this.n === 0) {
							this.$alert.success('自动登录成功！');
						} else {
							this.$alert.success('登录成功！');
						}

						this.showCode = false;

						this.$store.commit('updateUserInfo', userInfo);
						this.$store.commit('updateToken', token);

						const timers = setTimeout(() => {
							this.$router.push('/');
						}, 1500);
					} else {
						if (this.n > 100) {
							this.codeUrl = '';

							this.fetchCode();
							return;
						}

						this.refreshStatus();
						this.n++;
					}
				});
			}, 2000);
		},
		clear() {
			clearTimeout(this.timer);
		}
	},
	destroyed() {
		this.clear();
	},
	mounted() {
		this.clear();
		lsweb0001.send()
		this.$alert = this.isPhone ? Toast : this.$message;

		if (this.$store.state.token) {
			this.$router.push('/');
		} else {
			this.fetchCode();
		}
	}
};
</script>

<style lang="less">
.login {
	background: #e8f1ff;
	height: calc(100vh);
	position: relative;

	.left-image {
		position: absolute;
		left: 0;
		top: 0;
		width: 346px;
		height: 459px;
	}

	.right-top {
		width: 517px;
		height: 356px;
		position: absolute;
		right: 0;
		top: 0;
	}
	.right-bottom {
		width: 645px;
		height: auto;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	&-content {
		position: relative;
		// max-width: 1100px;
		margin: 0 auto;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		&__title {
			text-align: center;
			h1 {
				font-size: 31px;
				font-weight: 500;
				color: #212d44;
				line-height: 44px;
			}
			h6 {
				font-size: 18px;
				font-weight: 400;
				color: #748299;
				line-height: 14px;
				padding-top: 10px;
			}
			img {
				width: 296px;
				height: 214px;
				margin-top: 57px;
			}
			.phone-button {
				display: none;
			}
		}
		&__code {
			width: 325px;
			height: 350px;
			background: #ffffff;
			box-shadow: 0px 0px 4px 3px rgba(8, 27, 56, 0.03);
			border-radius: 10px;
			margin-left: 124px;
			display: flex;
			flex-direction: column;
			align-items: center;
			position: relative;

			.img {
				width: 300px;
				height: 300px;
				flex: 0 0 300px;
				margin-top: 15px;
				height: 244px;
				margin-bottom: -30px;
				color: #999;
			}
			&--tips {
				display: flex;
				font-size: 15px;
				font-weight: 400;
				color: #212d44;
				line-height: 25px;
				margin-top: 19px;
			}
		}
	}
}
</style>
